import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "../../API/axios";
import { toast } from "react-hot-toast";
import CommentReply from "./CommentReply";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { post } from "../../config/imagesLink";
import LikesDetails from "./LikesDetails";
import { useTranslation } from "react-i18next";
import ModalForGuest from "../ModalForGuest";

const {
  like,
  celebrate,
  support,
  love,
  insightful,
  funny,
  likegif,
  commentLike,
} = post;

const CommentReplyAction = ({
  item,
  AllPostList,
  emojiList,
  postId,
  setPostList,
  updateLikeCount,
  setSinglePostCommentList,
}) => {
  console.log("reply", item);
  const sessionId = localStorage.getItem("sessionId");
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredRelike, setIsHoveredRelike] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const { t } = useTranslation();
  const language = localStorage.getItem("Lang");
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);
  const guestModeData = localStorage.getItem("guestMode");

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const list = {
    visible: {
      opacity: 1,
    },
    hidden: {
      opacity: 0,
    },
  };

  //************************like Post start  ************************//
  const [selectedImg, setSelectedImage] = useState("");
  const [isLiking, setIsLiking] = useState(false);
  const [isLiked, setIsLiked] = useState(!!item?.isLiked);
  const [likedType, setLikedType] = useState(item?.likedType ?? null);
  const [localLikeCount, setLocalLikeCount] = useState(item?.likeCount ?? 0);

  React.useEffect(() => {
    setIsLiked(!!item?.isLiked);
    setLikedType(item?.likedType ?? null);
    setLocalLikeCount(item?.likeCount ?? 0);
  }, [item?.isLiked, item?.likedType]);

  
  const LikePost = async (liketype, imageName) => {
    // optimistic UI update
    setIsLiked(true);
    setLikedType(liketype);
    setLocalLikeCount((c) => (item?.isLiked ? c : c + 1));
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      pstCmntRplyId: item.pstCmntRplyId,
      likeType: liketype,
            langKey: language === "en" ? "" : language,

    };
    setIsLiking(true);
    setTimeout(async () => {
      try {
        await axios
          .post(`PostAction/LikeCommentReply`, responseData)
          .then((res) => {
            // console.log(res);
            // toast.success(res.data.message);
            setToastMessage(res.data.message);
            setShowToast(true);
                // AllPostList();
                updateLikeCount && updateLikeCount(postId, 1);
                setSelectedImage(imageName);
            setIsHovered(false);
            setIsLiking(false);
            setIsLiked(true);
            setLikedType(liketype);
            if (typeof setPostList === "function") {
              setPostList((prevList) =>
                prevList.map((post) => {
                  if (post.postInfo.postId !== postId) return post;

                  return {
                    ...post,
                    postInfo: {
                      ...post.postInfo,
                      comments: (post.postInfo.comments || []).map((c) => {
                        if (c.pstCmntId !== item.pstCmntId) return c;

                        return {
                          ...c,
                          commentsReplies: (c.commentsReplies || []).map((reply) => {
                            if (reply.pstCmntRplyId !== item.pstCmntRplyId) return reply;
                            return {
                              ...reply,
                              isLiked: true,
                              likeCount: reply.isLiked ? reply.likeCount : (reply.likeCount || 0) + 1,
                              likedType: liketype,
                            };
                          }),
                        };
                      }),
                    },
                  };
                })
              );

              // update single-post comment list if available
              if (typeof setSinglePostCommentList === "function") {
                setSinglePostCommentList((prev) =>
                  prev?.map((c) =>
                    c.pstCmntId !== item.pstCmntId
                      ? c
                      : {
                          ...c,
                          commentsReplies: (c.commentsReplies || []).map((reply) =>
                            reply.pstCmntRplyId !== item.pstCmntRplyId
                              ? reply
                              : {
                                  ...reply,
                                  isLiked: true,
                                  likeCount: reply.isLiked ? reply.likeCount : (reply.likeCount || 0) + 1,
                                  likedType: liketype,
                                }
                          ),
                        }
                  )
                );
              }
            }
          });
      } catch (e) {
        // revert optimistic
        setIsLiked(false);
        setLikedType(item?.likedType ?? null);
        setLocalLikeCount((c) => Math.max((c || 0) - 1, 0));
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data.message);
          setShowErrorToast(true);
        }
      }
    }, 1000);
  };


  const unLikePost = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: item.pstCmntRplyId,
      langKey: language === "en" ? "" : language,
    };

    // capture previous state to allow revert on error
    const prevLiked = Boolean(isLiked || item?.isLiked);
    const prevLikedType = changeLikedType || likedType || item?.likedType;

    // optimistic UI update: remove emoji and decrement counts immediately
    setIsLiked(false);
    setLikedType(null);
    setChangeLikedType(null);
    updateLikeCount && updateLikeCount(postId, -1);
    setLocalLikeCount((c) => Math.max((c || 0) - 1, 0));

    // also optimistically update parent post list so `item` prop reflects the change
        // update single-post comment list if available
        if (typeof setSinglePostCommentList === "function") {
          setSinglePostCommentList((prev) =>
            prev?.map((c) =>
              c.pstCmntId !== item.pstCmntId
                ? c
                : {
                    ...c,
                    commentsReplies: (c.commentsReplies || []).map((reply) =>
                      reply.pstCmntRplyId !== item.pstCmntRplyId
                        ? reply
                        : {
                            ...reply,
                            isLiked: false,
                            likedType: null,
                            likeCount: reply.isLiked ? (reply.likeCount > 0 ? reply.likeCount - 1 : 0) : reply.likeCount,
                          }
                    ),
                  }
            )
          );
        }
    if (typeof setPostList === "function") {
      setPostList((prevList) =>
        prevList.map((post) => {
          if (post.postInfo.postId !== postId) return post;

          return {
            ...post,
            postInfo: {
              ...post.postInfo,
              comments: (post.postInfo.comments || []).map((c) => {
                if (c.pstCmntId !== item.pstCmntId) return c;

                return {
                  ...c,
                  commentsReplies: (c.commentsReplies || []).map((reply) => {
                    if (reply.pstCmntRplyId !== item.pstCmntRplyId) return reply;
                    return {
                      ...reply,
                      isLiked: false,
                      likedType: null,
                      likeCount: reply.isLiked
                        ? Math.max((reply.likeCount || 0) - 1, 0)
                        : reply.likeCount,
                    };
                  }),
                };
              }),
            },
          };
        })
      );
    }

    setIsLiking(true);
    setTimeout(async () => {
      try {
        const res = await axios.post(`PostAction/UnlikeCommentReply`, responseData);
        setToastMessage(res.data.message);
        setShowToast(true);
        // AllPostList();
        setIsHovered(false);
        setIsHoveredRelike(false);
        setIsLiking(false);

        if (typeof setPostList === "function") {
          setPostList((prevList) =>
            prevList.map((post) => {
              if (post.postInfo.postId !== postId) return post;

              return {
                ...post,
                postInfo: {
                  ...post.postInfo,
                  comments: (post.postInfo.comments || []).map((c) => {
                    if (c.pstCmntId !== item.pstCmntId) return c;

                    return {
                      ...c,
                      commentsReplies: (c.commentsReplies || []).map((reply) => {
                        if (reply.pstCmntRplyId !== item.pstCmntRplyId) return reply;
                        // Only decrement if it was previously liked
                        return {
                          ...reply,
                          isLiked: false,
                          likeCount: reply.isLiked ? (reply.likeCount > 0 ? reply.likeCount - 1 : 0) : reply.likeCount,
                          likedType: null,
                        };
                      }),
                    };
                  }),
                },
              };
            })
          );
        }
      } catch (e) {
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data.message);
          setShowErrorToast(true);
          // Revert optimistic update
          setIsLiked(prevLiked);
          setLikedType(prevLikedType);
          setChangeLikedType(prevLikedType);
          // revert local count
          setLocalLikeCount((c) => (prevLiked ? (c || 0) + 1 : c));
          updateLikeCount && updateLikeCount(postId, 1, true, prevLikedType);
        }
        // Ensure any reaction picker is hidden after an error as well
        setIsHovered(false);
        setIsHoveredRelike(false);
      }
    }, 1000);
  };

  //************************like Post End  ************************//

  const [showCommentsReply, setShowCommentsReply] = useState(false);
  const [changeLikedType, setChangeLikedType] = useState(null);
  const toggleReplyComment = () => {
    setShowCommentsReply(!showCommentsReply);
  };
  const customCount = item.likeCount + 1;

  const getLikeCount = () => {
    if (isLiked || item.isLiked) {
      if (!item.isLiked && isLiked) {
        return item.likeCount + 1;
      }
      return item.likeCount;
    }
    return item.likeCount;
  };

  const currentLikedType =
    changeLikedType ?? (isLiked ? likedType : null);
  const displayCount = localLikeCount;

  const [showCommentReplyLikeModal, setShowCommentReplyLikeModal] = useState(false);
  const [postCommentReplyId, setPostCommentsReplyId] = useState(false);
  const [commentsReplyLikedType, setCommentsReplyLikedType] = useState(false);

  const handleShowCommentReplyLike = (item) => {
    console.log("comment rply id", item.pstCmntRplyId);
    setPostCommentsReplyId(item.pstCmntRplyId);
    setCommentsReplyLikedType(item.likedType);
    setShowCommentReplyLikeModal(true);
  };
  const handleCommentReplyLikeCloseModal = () => {
    setShowCommentReplyLikeModal(false);
  };

  const ReLikePost = async (liketype, imageName) => {
    // If user clicked the same emoji that's already selected, do nothing (avoid hitting API)
    const currentType = changeLikedType || likedType || item?.likedType;
    if (Number(currentType) === Number(liketype)) {
      setIsHoveredRelike(false);
      return;
    }

    // If the reply wasn't previously liked, treat this as a new like
    const wasLiked = Boolean(isLiked || item?.isLiked);
    if (!wasLiked) {
      setIsHoveredRelike(false);
      return LikePost(liketype, imageName);
    }

    // optimistic
    setChangeLikedType(liketype);

    try {
      const responseData = {
        deviceType: "Web",
        sessionId: sessionId,
        pstCmntRplyId: item.pstCmntRplyId,
        likeType: liketype,
        langKey: language === "en" ? "" : language,

      };
      setIsLiking(true);
      setLikedType(liketype);

      const res = await axios.post("/PostAction/ChangeCommentReplyLikeType", responseData);

      setToastMessage(res.data.message);
      setShowToast(true);
      setSelectedImage(imageName);
      setIsHoveredRelike(false);
      setIsLiking(false);
      setIsLiked(true);
      setLikedType(liketype);
      setChangeLikedType(liketype);

      // Update parent post list so like types stay in sync
      if (typeof setPostList === "function") {
        setPostList((prevList) =>
          prevList.map((post) => {
            if (post.postInfo.postId !== postId) return post;

            return {
              ...post,
              postInfo: {
                ...post.postInfo,
                comments: (post.postInfo.comments || []).map((c) => {
                  if (c.pstCmntId !== item.pstCmntId) return c;

                  return {
                    ...c,
                    commentsReplies: (c.commentsReplies || []).map((reply) => {
                      if (reply.pstCmntRplyId !== item.pstCmntRplyId) return reply;
                      return {
                        ...reply,
                        likedType: liketype,
                        isLiked: true,
                      };
                    }),
                  };
                }),
              },
            };
          })
        );
      }

      // update single-post comment list likedType if available
      if (typeof setSinglePostCommentList === "function") {
        setSinglePostCommentList((prev) =>
          prev?.map((c) =>
            c.pstCmntId !== item.pstCmntId
              ? c
              : {
                  ...c,
                  commentsReplies: (c.commentsReplies || []).map((reply) =>
                    reply.pstCmntRplyId !== item.pstCmntRplyId
                      ? reply
                      : { ...reply, likedType: liketype, isLiked: true }
                  ),
                }
          )
        );
      }

      // Fetch the full post details using the post ID
      // const postDetailsResponse = await axios.get(`/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}`);
      // const updatedPost = postDetailsResponse.data.responseData;
      // console.log('updatedPost', updatedPost);

      // // Update the existing post in the list
      // setPostList((prev) =>
      //   prev.map((post) =>
      //     post.postId === updatedPost.postId ? updatedPost : post
      //   )
      // );
    } catch (e) {
       console.log(e);
    //   if (e.response && e.response.status === 404) {
    //     setWarningToastMessage(e.response.data.message);
    //     setShowWarningToast(true);
    //   } else {
    //     setErrorToastMessage(e.response.data.message);
    //     setShowErrorToast(true);
    //   }
    // }
     if (e.response) {
        if (e.response.status === 404) {
          setWarningToastMessage(e.response.data?.message || "Not found");
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data?.message || "Something went wrong");
          setShowErrorToast(true);
        }
      } else {
        setErrorToastMessage(e.message || "Unexpected error occurred");
        setShowErrorToast(true);
      }
    }
  };


  const [followModal, setFollowModal] = useState(false);
        const closeModalData = () => {
          setFollowModal(false);
        };

  return (
    <>
    {guestModeData === "true" ? (
      <div className="commentAction ms-3">
        <span className="CommentlikeActions d-flex align-items-center">
          {isLiked === true ? (
            <div
              className="like-container pointer d-flex align-items-center me-2"
             onClick={() => {
                              setFollowModal(true);
                            }}
              // whileHover={{ scale: 1.3 }}
              onMouseEnter={() => setIsHoveredRelike(true)}
              onMouseLeave={() => setIsHoveredRelike(false)}
              // onClick={() => {
              //   if (!isHoveredRelike) {
              //     unLikePost();
              //   }
              // }}
            >
              {currentLikedType === 1 ? (
                <>
                  <img src={post.LikeGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                </>
              ) : currentLikedType === 2 ? (
                <>
                  <img src={post.LoveGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Love")}</p>
                </>
              ) : currentLikedType === 3 ? (
                <>
                  <img
                    src={post.LaughingGif}
                    width={15}
                    className="likepadding"
                  />
                  <p className="f-12 ms-1">{t("Newsfeed.Laugh")}</p>
                </>
              ) : currentLikedType === 4 ? (
                <>
                  <img src={post.WowGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Wow")}</p>
                </>
              ) : currentLikedType === 5 ? (
                <>
                  <img src={post.AngryGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Angry")}</p>
                </>
              ) : (
                <>
                  <img src={post.LikeGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                </>
              )}
            </div>
          ) : (
            <motion.span
              className="f-12 me-2 pointer"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={() => {
                              setFollowModal(true);
                            }}
            >
              {t("Newsfeed.Like")}
            </motion.span>
          )}
          {displayCount > 0 ? (
            <span
              className={`commentLike me-2 ${!isLiked ? "like-details" : ""}`}
              onClick={() => handleShowCommentReplyLike(item)}
            >
              {displayCount}
            </span>
          ) : null}

          {isHovered && (
            <motion.div
              className="reactionsHolder"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              variants={list}
              animate={isHovered ? "visible" : "hidden"}
            >
              {emojiList.map((item) => {
                return (
                  <div className="emoji-container" key={item.value}>
                    <motion.img
                      whileHover={{ scale: 1.5 }}
                      src={item.url}
                      alt=""
                      onClick={() => {
                        setFollowModal(true);
                      }}
                    />
                    <span className="emoji-name">{item.name}</span>
                  </div>
                );
              })}
            </motion.div>
          )}
          {isHoveredRelike && (
            <motion.div
              className="reactionsHolder"
              onMouseEnter={() => setIsHoveredRelike(true)}
              onMouseLeave={() => setIsHoveredRelike(false)}
              variants={list}
            >
              {emojiList?.map((item) => {
                return (
                  <div className="emoji-container" key={item.value}>
                    <motion.img
                      whileHover={{ scale: 1.5 }}
                      src={item.url}
                      alt=""
                      // onClick={() => {
                      //   ReLikePost(item.value, item.name);
                      // }}
                      onClick={() => {
                              setFollowModal(true);
                            }}
                    />
                    <span className="emoji-name">{item.name}</span>
                  </div>
                );
              })}
            </motion.div>
          )}
        </span>
      </div>
    ) : (
      <div className="commentAction ms-3">
        <span className="CommentlikeActions d-flex align-items-center">
          {isLiked === true ? (
            <div
              className="like-container pointer d-flex align-items-center me-2"
              onClick={() => unLikePost()}
              // whileHover={{ scale: 1.3 }}
              onMouseEnter={() => setIsHoveredRelike(true)}
              onMouseLeave={() => setIsHoveredRelike(false)}
              // onClick={() => {
              //   if (!isHoveredRelike) {
              //     unLikePost();
              //   }
              // }}
            >
              {currentLikedType === 1 ? (
                <>
                  <img src={post.LikeGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                </>
              ) : currentLikedType === 2 ? (
                <>
                  <img src={post.LoveGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Love")}</p>
                </>
              ) : currentLikedType === 3 ? (
                <>
                  <img
                    src={post.LaughingGif}
                    width={15}
                    className="likepadding"
                  />
                  <p className="f-12 ms-1">{t("Newsfeed.Laugh")}</p>
                </>
              ) : currentLikedType === 4 ? (
                <>
                  <img src={post.WowGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Wow")}</p>
                </>
              ) : currentLikedType === 5 ? (
                <>
                  <img src={post.AngryGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Angry")}</p>
                </>
              ) : (
                <>
                  <img src={post.LikeGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                </>
              )}
            </div>
          ) : (
            <motion.span
              className="f-12 me-2 pointer"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={() => {
                LikePost(1, like);
              }}
            >
              {t("Newsfeed.Like")}
            </motion.span>
          )}
          {displayCount > 0 ? (
            <span
              className={`commentLike me-2 ${!isLiked ? "like-details" : ""}`}
              onClick={() => handleShowCommentReplyLike(item)}
            >
              {displayCount}
            </span>
          ) : null}

          {isHovered && (
            <motion.div
              className="reactionsHolder"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              variants={list}
              animate={isHovered ? "visible" : "hidden"}
            >
              {emojiList.map((item) => {
                return (
                  <div className="emoji-container" key={item.value}>
                    <motion.img
                      whileHover={{ scale: 1.5 }}
                      src={item.url}
                      alt=""
                      onClick={() => {
                        LikePost(item.value, item.name);
                      }}
                    />
                    <span className="emoji-name">{item.name}</span>
                  </div>
                );
              })}
            </motion.div>
          )}
          {isHoveredRelike && (
            <motion.div
              className="reactionsHolder"
              onMouseEnter={() => setIsHoveredRelike(true)}
              onMouseLeave={() => setIsHoveredRelike(false)}
              variants={list}
            >
              {emojiList?.map((item) => {
                return (
                  <div className="emoji-container" key={item.value}>
                    <motion.img
                      whileHover={{ scale: 1.5 }}
                      src={item.url}
                      alt=""
                      onClick={() => {
                        ReLikePost(item.value, item.name);
                      }}
                    />
                    <span className="emoji-name">{item.name}</span>
                  </div>
                );
              })}
            </motion.div>
          )}
        </span>
      </div>
    )}

      {followModal && <ModalForGuest closeModalData={closeModalData} />}


      {showCommentsReply && (
        <CommentReply
          item={item}
          AllPostList={AllPostList}
          setPostList={setPostList}
          postId={postId}
          commentId={item.pstCmntId}
          toggleReplyComment={toggleReplyComment}
        />
      )}

      <LikesDetails
        showCommentReplyLikeModal={showCommentReplyLikeModal}
        handleCommentReplyLikeCloseModal={handleCommentReplyLikeCloseModal}
        commentsReplyLikedType={commentsReplyLikedType}
        postCommentReplyId={postCommentReplyId}
      />

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default CommentReplyAction;
